const vi = {
  date_format1: 'DD/MM/YYYY',
  date_format2: 'YYYY-MM-DD',
  date_format3: 'DD/MM/YY',
  day_month_format: 'DD/MM',
  welcome: 'Welcome to React JS',
  app_name: 'Mobile Web App',
  login: 'Login',
  username: 'Username',
  password: 'Password',
  view_all: 'View all',
  your_info: 'Thông tin của bạn',
  please_confirm_age_and_gender: 'Vui lòng xác nhận các thông tin dưới đây',
  full_name: 'Họ và tên',
  male: 'Nam',
  female: 'Nữ',
  gender: 'Giới tính',
  continue: 'Tiếp theo',
  insurance_benefit: 'Quyền lợi bảo hiểm',
  insurance_service: 'Dịch vụ bảo hiểm',
  annual_fee: 'Đóng phí hàng năm',
  choose_now: 'Chọn ngay',
  choosed: 'Đã chọn',
  cancer_benefit: 'Quyền lợi Bệnh ung thư',
  live_benefit: 'Quyền lợi sống khoẻ',
  insurance_period: 'Thời hạn bảo hiểm',
  issue_new_contract_benefit: 'Quyền đảm bảo phát hành hợp đồng mới',
  health_question: 'Câu hỏi sức khoẻ',
  confirm_info: 'Xác nhận thông tin',
  confirm_info_hint:
    'Tôi xác nhận các thông tin dưới đây là hoàn toàn chính xác để đăng ký yêu cầu bảo hiểm của MB Ageas.',
  require_hint: '(*) là trường thông tin bắt buộc',
  full_name_insurance: 'Họ và tên BMBH và NĐBH',
  identity_card_type: 'Loại giấy tờ tuỳ thân ',
  identity_card_number: 'Số giấy tờ tuỳ thân',
  dob: 'Ngày sinh',
  dob_full: 'Ngày tháng năm sinh',
  dob_full_ph: 'Ngày tháng năm sinh(của người mua BH)',
  address: 'Địa chỉ',
  phone: 'Số điện thoại',
  confirm_info_email_hint: '(Nhận toàn bộ HĐBH và thông báo từ MB Ageas Life)',
  email: 'Email',
  commitment: 'Cam kết',
  commitment_hint: 'Cam kết của Bên mua Bảo hiểm và Người được bảo hiểm',
  view_term: 'Xem Quy tắc, Điều khoản sản phẩm',
  im_agree_join_insurance: 'Tôi cam kết và đồng ý tham gia bảo hiểm',
  i_read_and_agree_term:
    'Tôi đã đọc và đồng ý với Quy tắc, Điều khoản sản phẩm ',
  i_read_and_agree_with: 'Tôi đã đọc và đồng ý với',
  term_and_condition: 'Quy tắc, Điều khoản sản phẩm',
  payment: 'Thanh toán',
  im_agree_pay_with_info: 'Tôi đồng ý thanh toán với thông tin như sau',
  im_agree_grant_permission:
    'Tôi đồng ý ủy quyền cho MB tự động trích trừ từ Tài khoản đã lựa chọn tại YCBH này để thanh toán Phí bảo hiểm của các kỳ phí tiếp theo cho MB Ageas Life theo Quy định của MB và MB Agesa Life.',
  confirm_pay: 'Xác nhận thanh toán',
  referral_code: 'Mã giới thiệu',
  referral_code_hint: 'Nhập số tài khoản người giới thiệu',
  referral_code_guide:
    'Mã giới thiệu là số tài khoản hợp lệ của MBBank. Trường hợp sai số tài khoản, Người giới thiệu sẽ không nhận được thưởng của chương trình',
  term_fee: 'Định kỳ đóng phí',
  pay_money: 'Số tiền thanh toán',
  pay_info: 'Thông tin thanh toán',
  account_info: 'Thông tin tài khoản',
  account_number: 'Số tài khoản',
  balance: 'Số dư',
  home: 'Trang chủ',
  account: 'Cá nhân',
  view_more: 'Xem thêm',
  pay_insurance_fee: 'Thanh toán\nphí BH',
  search_insurance_contract: 'Hợp đồng\ncủa tôi',
  book_consultant: 'Đặt lịch\ntư vấn',
  invite_customer: 'Giới thiệu\nKhách hàng',
  insurance_product: 'Sản phẩm bảo hiểm',
  new_and_discount: 'Tin tức và Khuyến mại',
  buy_insurance_online: 'Mua bảo hiểm Online',
  logo: 'Bảo hiểm MB Ageas Life',
  promotion_code: 'Mã khuyến mại',
  apply: 'Áp dụng',
  cancel_apply: 'Huỷ áp dụng',
  expire_date_label: 'HSD',
  promotion_code_applied: 'mã khuyến mại đã được áp dụng',
  first_year_fee: 'Phí năm đầu',
  notification: 'Thông báo',
  session_expired_message:
    'Hết phiên đăng nhập. Bạn vui lòng đăng nhập lại để tiếp tục sử dụng dịch vụ',
  ok: 'Đồng ý',
  close: 'Đóng',
  nationality: 'Quốc tịch',
  choose_nationality: 'Chọn Quốc tịch',
  search: 'Tìm kiếm',
  confirm_quit_cancer:
    'Yêu cầu bảo hiểm sẽ không được lưu lại khi chưa hoàn tất việc thanh toán. Quý khách có chắc chắn muốn dừng lại không?',
  cancel: 'Huỷ',
  dob_required: 'Ngày sinh bắt buộc nhập',
  gender_required: 'Giới tính bắt buộc chọn',
  address_required: 'Địa chỉ bắt buộc nhập',
  exit: 'Thoát',
  stay: 'Ở lại',
  err_nation:
    'Sản phẩm chưa hỗ trợ cho khách hàng nước ngoài. Vui lòng liên hệ hotline MB Ageas Life 024 7309 9866 để được hỗ trợ',
  contact_now: 'Liên hệ ngay',
  later: 'Để sau',
  hotline: '02422298888',
  hotline2: '02473099866',
  general_error: 'Rất tiếc! Đã xảy ra lỗi. Vui lòng thử lại',
  no_internet:
    'Thiết bị của Quý khách đang ngoại tuyến. Vui lòng kiểm tra kết nối internet và thử lại',
  promotion: 'Khuyến mại',
  news: 'Tin tức',
  main_product: 'Sản phẩm chính',
  supplementary_product: 'Sản phẩm bổ trợ',
  online_product: 'Sản phẩm bán Online',
  finished: 'Đã kết thúc',
  buy_insurrance: 'Mua bảo hiểm',
  insurrance_amount: 'Số tiền bảo hiểm',
  pay_method_and_term: 'Phương thức và Định kỳ đóng phí',
  insurrance_fee: 'Phí bảo hiểm',
  method_auto_debit: 'Trích trừ tự động từ tài khoản ngân hàng hàng tháng.',
  request_insurrance: 'Yêu cầu bảo hiểm',
  request_insurrance_guide:
    'Thông tin trên Yêu cầu bảo hiểm là thông tin mặc định mà khách hàng đã đăng ký tại MB Bank, vui lòng điều chỉnh nếu thông tin chưa chính xác.',
  issued_date: 'Ngày cấp',
  issued_place: 'Nơi cấp',
  email_placeholder: 'Nhập email',
  email_required: 'Email bắt buộc nhập',
  full_name_buyer: 'Họ và tên Bên mua BH/Người được BH',
  confirm: 'Xác nhận',
  happening: 'Đang diễn ra',
  upcoming: 'Sắp diễn ra',
  year: 'năm',
  question: 'Câu hỏi',
  yes: 'Có',
  no: 'Không',
  anual: 'Hàng năm',
  please_answer_health_question:
    'Quý khách vui lòng trả lời đầy đủ các câu hỏi sức khỏe để tiếp tục',
  we_cant_accept_your_insurance_request:
    'Chúng tôi rất tiếc chưa thể chấp nhận yêu cầu bảo hiểm của Quý khách tại thời điểm hiện tại. Vui lòng liên hệ hotline MB Ageas Life 024 7309 9866 để được tư vấn thêm',
  invalid_email: 'Email không hợp lệ',
  please_read_term_and_condition:
    'Quý khách vui lòng đọc, đồng ý với Quy tắc, điều khoản sản phẩm và cam kết đồng ý tham gia bảo hiểm để tiếp tục',
  address_placeholder: 'Nhập địa chỉ',
  err_referral_code:
    'Vui lòng nhập mã giới thiệu là số tài khoản hợp lệ tại MBBank (không chứa ký tự chữ và ký tự đặc biệt)',
  please_choose_insurance_package:
    'Quý khách vui lòng chọn một gói quyền lợi bảo hiểm để tiếp tục',
  no_product: 'Chưa có sản phẩm nào',
  no_news: 'Chưa có tin tức nào',
  no_promotion: 'Chưa có khuyến mại nào',
  cancer_insurrance_name: 'Ung dung sống khoẻ',
  cancer_insurrance_desc: 'Quan tâm mỗi ngày, ung dung từng giây',
  important_feature: 'Đặc điểm nổi bật',
  cancer_feature_2:
    'Quyền cam kết phát hành hợp đồng mới không cần thẩm định lại sức khỏe',
  cancer_feature_3:
    'Tham gia nhanh chóng chỉ với 4 bước trên ứng dụng MB App để có ngay hợp đồng bảo hiểm',
  more_info_about_product: 'Thông tin thêm về sản phẩm',
  cancer_info_note:
    '* Quyền lợi không áp dụng cho bệnh ung thư có dấu hiệu và triệu chứng xuất hiện trước và trong vòng 90 ngày kể từ ngày hiệu lực hợp đồng, trừ trường hợp hợp đồng được phát hành theo quyền cam kết phát hành hợp đồng mới.',
  age_join_insurrance: 'Tuổi tham gia BH',
  contract_term: 'Thời hạn hợp đồng',
  fee_payment_deadline: 'Thời hạn đóng phí',
  pay_fee_online: 'Đóng phí trực tuyến',
  view_detail: 'Xem chi tiết',
  ycbh_number: 'Số hồ sơ yêu cầu bảo hiểm',
  ycbh_input_hint: 'Nhập số hồ sơ yêu cầu bảo hiểm',
  pay_fee_ycbh: 'Đóng phí cho HSYCBH',
  document_info: 'Thông tin hồ sơ',
  ycbh_number2: 'Số HSYCBH',
  insurance_buyer: 'Bên mua bảo hiểm',
  insurancer: 'Người được bảo hiểm',
  product: 'Sản phẩm',
  insurance_fee_pay: 'Phí bảo hiểm thanh toán',
  provisional_first_time_fee: 'Phí lần đầu tạm tính',
  additional_insurance_fee: 'Phí bảo hiểm đóng thêm',
  total_fee: 'Tổng phí thanh toán',
  ycbh_number_required: 'Số hồ sơ yêu cầu bảo hiểm bắt buộc nhập',
  periodic_payment: 'Đóng phí Định kỳ',
  pay_fee_addition: 'Đóng phí đóng thêm',
  pay_fee_addition_1: 'Phí đóng thêm',
  chooser_type_pay_fee: 'Chọn loại đóng phí',
  feature_in_development: 'Chức năng đang trong quá trình phát triển',
  confirm_quit_pay_fee:
    'Yêu cầu đóng phí sẽ không được lưu lại khi chưa hoàn tất việc thanh toán. Quý khách có chắc chắn muốn dừng lại không?',
  voucher_code_input_hint: 'Nhâp mã khuyến mại',
  detail: 'Chi tiết',
  apply_voucher: 'Áp dụng khuyến mại',
  decrease_amount: 'Số tiền giảm',
  insurance_fee_after_discount: 'Phí BH năm đầu sau khuyến mại',
  apply_period: 'Thời gian áp dụng',
  not_apply_voucher_yet: 'Bạn chưa áp dụng chương trình khuyến mại nào.',
  appling_voucher_part1: 'Bạn đang áp dụng mã khuyến mại',
  appling_voucher_part2: ', được giảm',
  appling_voucher_part3: 'phí bảo hiểm năm đầu.',
  cancer_pay_success:
    'Chúc mừng Quý khách đã mua bảo hiểm thành công. Bộ hợp đồng bảo hiểm điện tử sẽ được MB Ageas Life gửi tới Quý khách qua địa chỉ email và số điện thoại đã đăng ký tại Yêu cầu bảo hiểm.',
  go_home: 'Về trang chủ',
  contract_info: 'Thông tin hợp đồng',
  contract_number: 'Số hợp đồng',
  invalid_vouhcer_code: 'Mã khuyến mại không hợp lệ',
  apply_from: 'Áp dụng từ',
  apply_voucher2: 'Áp dụng mã khuyến mại',
  'discount-first-year':
    'Bạn đang áp dụng CTKM nhận e-voucher giảm *****% phí bảo hiểm năm đầu cho sản phẩm Bảo hiểm Ung dung sống khoẻ. Hạn sử dụng e-voucher: đến hết ngày 30/11/2021',
  'discount-first-year-with-limit':
    'Bạn đang áp dụng CTKM nhận e-voucher giảm *****% và không quá ***** VNĐ phí bảo hiểm năm đầu cho sản phẩm Bảo hiểm Ung dung sống khoẻ. Hạn sử dụng e-voucher: đến hết ngày 30/11/2021',
  'discount-first-year-vnd':
    'Bạn đang áp dụng CTKM nhận e-voucher giảm ***** VNĐ phí bảo hiểm năm đầu cho sản phẩm Bảo hiểm Ung dung sống khoẻ. Hạn sử dụng e-voucher: đến hết ngày 30/11/2021',
  'discount-first-year-vnd-remain':
    'Bạn đang áp dụng CTKM nhận e-voucher giảm còn ***** VNĐ cho sản phẩm Bảo hiểm Ung dung sống khoẻ. Hạn sử dụng e-voucher: đến hết ngày 30/11/2021',
  // my policy
  identity_card_number_public: 'Chứng minh nhân dân/Căn cước công...',
  type_identity: 'Loại giấy tờ tùy thân',
  identification: 'Giấy tờ tùy thân',
  insurance_contract: 'Hợp đồng bảo hiểm',
  policy_number: 'Số hợp đồng bảo hiểm',
  contract_search: 'Tìm kiếm hợp đồng',
  insurance_claim_number: 'Số hồ sơ yêu cầu bảo hiểm',
  insurance_policy_number: 'Số hợp đồng bảo hiểm',
  search_policy_info: 'Hợp đồng của tôi',
  identify_card_type: 'Loại giấy tờ',
  identify_card_number: 'Số giấy tờ tuỳ thân',
  insurance_buyer_info: 'Thông tin bên mua bảo hiểm',
  no_policy: 'Quý khách hiện tại không có hợp đồng nào',
  identify_card_number_1: 'Chứng minh nhân dân/ căn cước công dân',
  all: 'Tất cả',
  active: 'Đang hiệu lực',
  active_1: 'Hiệu lực',
  active_2: 'Đang hoạt động',
  lapsed: 'Mất hiệu lực',
  list_policy: 'Danh sách HĐBH',
  change_contract_info: 'Thay đổi thông tin hợp đồng',
  cancel_contract: 'Hủy hợp đồng',
  msg_11: 'Không áp dụng với Hợp đồng bảo hiểm này',
  periodic: 'Phí định kỳ',
  periodic_1: 'Phí bảo hiểm định kỳ',
  annual_fee_1: 'Phí thường niên',
  hint_additional_insurance_fee:
    'Khoản đầu tư thêm sau khi đóng đầy đủ Phí bảo hiểm định kỳ',
  manage_policy: 'Quản lý hợp đồng',
  policy_start_date: 'Ngày hiệu lực',
  agent_name: 'Tên đại lí phục vụ',
  agent_phone: 'Số điện thoại đại lí',
  agent_code: 'Mã đại lí',
  min: 'Tối thiểu',
  max: 'Tối đa',
  select_payment_fees: 'Chọn các khoản phí thanh toán',
  excess_payment: 'Số tiền còn dư',
  msg_09:
    'Giá trị phí đóng thêm phải phù hợp với điều kiện sau: là bội số 100,000 VND và lớn hơn giá trị tối thiểu và nhỏ hơn giá trị tối đa.',
  msg_13: 'Không thể thực hiện giao dịch khi số tiền bằng 0',
  topup_fee_hint: 'Nhập số tiền đóng thêm',
  chooser_type_identity_card: 'Chọn loại giấy tờ tùy thân',
  complete: 'Hoàn thành',
  hint_insurance_policy_number: 'Nhập số hợp đồng bảo hiểm',
  policy_number_required: 'Số hợp đồng bảo hiểm bắt buộc nhập',
  confirm_quit: 'Quý khách có thực sự muốn thoát không?',
  msg_06:
    'Giao dịch không thể thực hiện do chưa hoàn tất thanh toán phí bảo hiểm định kỳ. Vui lòng thực hiện thanh toán.',
  cancel_policy: 'Hủy hợp đồng',
  confirm_cancel_policy: 'Xác nhận hủy hợp đồng',
  completed: 'Hoàn tất',
  request_type: 'Loại yêu cầu',
  request_date: 'Ngày yêu cầu',
  termination_contract: 'Hợp đồng chấm dứt hiệu lực từ ngày',
  account_completion_money:
    'Tài khoản nhận hoàn phí (chỉ áp dụng tài khoản mở tại ngân hàng TMCP Quân đội)',
  account_completion_money_1: 'Tài khoản nhận hoàn phí',
  reason_hint: 'Nhập lý do',
  cancel_reason: 'Lý do huỷ',
  agree_term:
    'Tôi sẽ không được hoàn phí hay nhận lại bất kỳ một khoản tiền nào',
  agree_term_1:
    'Kể từ ngày HĐ chấm dứt hiệu lực, MB Ageas Life không còn trách nhiệm bảo hiểm đối với Người được bảo hiểm của HĐBH số',
  agree_term_2:
    'Sau khi yêu cầu này được MB Ageas Life chấp thuận, MB Ageas Life không còn bất kỳ trách nhiệm bảo hiểm nào đối với Người được bảo hiểm của HĐBH số',
  confirm_cancel:
    'Tôi xác nhận đồng ý hủy HĐ số <strong>{{insurancePolicyNumber}}</strong> Số tiền bảo hiểm {{insuranceAmount}} VND với nội dung chi tiết như dưới đây:',
  please_confirm_agree_term:
    'Quý khách vui lòng xác nhận đồng ý với các điều kiện hủy HĐBH để tiếp tục',
  cancel_policy_msg_08: 'Quý khách vui lòng chọn ít nhất một lý do hủy',
  cancel_policy_msg_09: 'Quý khách vui lòng nhập lý do hủy',
  periodic_payment_1: 'Đóng Phí định kỳ',
  cancel_policy_type_1: 'Hủy HĐBH và hoàn phí về tài khoản',
  cancel_policy_type_2: 'Hủy HĐBH theo yêu cầu khách hàng',
  cancel_policy_content: 'Quý khách có thực sự muốn hủy HĐBH số {{policyNum}}?',
  complete_cancel_content_1:
    'Yêu cầu hủy HĐBH số <strong>{{policyNum}}</strong> của Quý khách đã được tiếp nhận thành công. Quý khách vui lòng kiểm tra kết quả chi tiết tại Email/SMS Quý khách đã đăng ký với MB Ageas Life.',
  complete_cancel_content_2:
    'Cảm ơn Quý khách đã sử dụng dịch vụ của MB Ageas Life. Mọi thắc mắc vui lòng liên hệ Tổng đài chăm sóc khách hàng của MB Ageas Life <strong>024 2229 8888</strong>.',
  complete_cancel_title: 'Gửi yêu cầu hủy thành công',
  other_fee: 'Phí khác',
  top_up_input_disabled_hint: 'Phí đóng thêm của bạn đã đạt mức tối đa 1 năm.',
  please_reason_hint: 'Vui lòng nhập lý do',
  copied: 'Đã sao chép',
  second: 'giây',
  otp_toolbar: 'Nhập OTP',
  resend_otp: 'Bạn có thể yêu cầu mã mới sau',
  resend_otp_1: 'Gửi lại mã',
  input_otp_hint: 'Mật khẩu một lần (OTP) đã được gửi tới SĐT {{phone}}',
  input_otp_hint_1:
    'Quý khách vui lòng nhập mã OTP đã được gửi về số điện thoại {{phone}} để xác nhận HỦY Hợp đồng bảo hiểm số {{policyNum}} - Người được bảo hiểm {{assuredName}} tại Công ty MB Ageas Life.',
  otp_include_6_digit: 'Mã xác thực gồm 6 ký tự',
  bp_has_paid: 'Hợp đồng này đã được thanh toán!',
  err_account_completion_money: 'Không đúng định dạng',
  account_completion_money_hint: 'Nhập số tài khoản',
  account_completion_money_required: 'Tài khoản nhận hoàn phí bắt buộc nhập',
  account_completion_money_invalid:
    'Tài khoản nhận hoàn phí không đúng định dạng',
  account_completion_money_name: 'Tên chủ tài khoản',
  account_completion_money_name_hint: 'Nhập tên chủ tài khoản',
  account_completion_money_name_required:
    'Tên tài khoản nhận hoàn phí bắt buộc nhập',
  account_completion_money_name_invalid:
    'Tên khoản nhận hoàn phí không đúng định dạng',
  insurance_package: 'Gói bảo hiểm',
  huge_refund: 'Hoàn tiền cực khủng',
  special_offers_insurance_price_ads: 'Chỉ từ 16 nghìn đồng/ngày',
  special_offers_huge_refund_detail_4: ' 100tr đồng',
  special_offers_huge_refund_detail_5: ' BH Ung thư, Quyền lợi bảo vệ lên tới',
  special_offers_contract_number: 'Số Hợp đồng Bảo hiểm (nếu có)',
  special_offers_contract_number_placeholder: 'Nhập số HĐBH',
  special_offers_agree_get_advise:
    'Tôi đồng ý nhận tư vấn Bảo hiểm của MB Ageas',
  special_offers_label: 'Ưu đãi KH hiện hữu',
  special_offers_refund: 'Hoàn',
  special_offers_contract_number_invalid: 'Số hợp đồng bảo hiểm không hợp lệ, vui lòng nhập lại.',
  special_offers_donate_voucher_1: 'Tặng Voucher TKSĐ bát quý lên tới',
  special_offers_up_to_500_m: '500 triệu đồng',
  special_offers_success_message_1:
    'Chúc mừng bạn đã Đăng ký thành công chương trình: ',
  special_offers_success_message_2: 'Chạm liền tay - Bảo vệ ngay',
  special_offers_success_message_3:
    'Chuyên viên tư vấn MB Ageas sẽ liên hệ lại trong vòng 24 giờ tới.',
  special_offers_package_detail_1_1: "Chi trả viện phí từ",
  special_offers_package_detail_1_2: "0,5 - 1 triệu đồng/ngày",
  special_offers_package_detail_1_3: "nằm viện.",
  special_offers_package_detail_2_1: "Hỗ trợ phẫu thuật từ",
  special_offers_package_detail_2_2: "5 - 50 triệu đồng/ca",
  special_offers_package_detail_3_1: "Chi trả hiểm nghèo lên đến",
  special_offers_package_detail_3_2: "200 triệu",
  special_offers_package_detail_4_1: "Bảo vệ tính mạng, tai nạn lên đến",
  special_offers_package_detail_4_2: "3 tỷ",
  special_offers_package_detail_5_1: "Tài khoản tích lũy từ",
  special_offers_package_detail_5_2: "200 - 500 triệu đồng",
  special_offers_refund_1: "Tài khoản số đẹp bát quý giá trị lên đến",
  refund: "Hoàn tiền",
  x_millions: " {{value}} triệu",
  up_to: "lên đến",
  voucher: "Voucher",
  special_offers_refund_2_1: "Bảo hiểm Ung thư lên tới",
  special_offers_refund_2_2: ", Quyền lợi bảo vệ lên đến",
  no_mb_account: "Quý khách hiện không có số tài khoản tại ngân hàng TMCP MB để thực hiện hoàn phí. Vui lòng liên hệ Tổng đài chăm sóc khách hàng của MB Ageas Life 024 2229 8888 để được hỗ trợ.",
  great_deals: "Ưu đãi cực khủng",
  insurance_consultant_code: "Mã chuyên viên tư vấn bảo hiểm",
  input_insurance_consultant_code: "Nhập mã chuyên viên tư vấn bảo hiểm",
  product_detail: "Chi tiết sản phẩm",
  insurance_consultant_code_invalid: "Mã chuyên viên tư vấn bắt buộc 10 số.",
  insurance_consultant_code_is_require: "Mã Chuyên viên tư vấn bắt buộc nhập.",
  special_offers_local_account_success_message_1:
    'Chúc mừng bạn Đăng ký thành công chương trình ',
  special_offers_local_account_success_message_2: 'Tài khoản địa phương - Gắn kết yêu thương',
  special_offers_local_account_success_message_3:
    'Chuyên viên tư vấn MB Ageas Life sẽ liên hệ lại trong vòng 24h tới.',
  account_beauty_number: "Tài khoản số đẹp bát quý trị giá lên đến",
  service_donation_local_account: "Tặng dịch vụ Bảo lãnh viện phí và Tư vấn",
  free: "miễn phí",
  local_account: "Tài khoản địa phương",
  payment_online: "Đóng phí trực tuyến",
  x_vnd: "{{value}} VND",
  special_offers_refund_2: "Bảo hiểm Ung thư, Quyền lợi bảo vệ lên đến",
  rm_code: "Mã RM giới thiệu",
  input_rm_code: "Nhập mã RM giới thiệu",
  rm_code_invalid: "Mã RM giới thiệu tối đa 12 ký tự",
  rm_code_is_require: "Mã RM giới thiệu bắt buộc nhập!",
  //special offer customer campaign
  special_offers_rm_code_label: "Mã RM tư vấn (nếu có)",
  special_offers_rm_code_hint: "Nhập mã RM phục vụ (MBxxxxx)",
  special_offers_rm_name_hint: "Tên RM",
  special_offers_rm_code_invalid: "Thông tin nhập không được phép vượt quá tối đa 10 ký tự hoặc chứa ký tự đặc biệt",
  special_offers_rm_name_required: "Tên RM bắt buộc nhập",
  cashback: "Hoàn tiền mặt",
  special_offers_safety_insurance: "phí bảo hiểm (hoặc tương đương)",
  special_offers_lucky_draw: "Chương trình Quay số trúng thưởng với tổng giá trị lên tới",
  x_millions_years: " {{value}} triệu đồng/năm",
  x_billions: " {{value}} tỷ đồng",
  special_offers_accident_benefits_up_to: "Quyền lợi tai nạn lên tới",
  special_offers_inpatient_benefits_up_to: "Quyền lợi điều trị nội trú lên tới",
  special_offers_outpatient_benefits_up_to: "Quyền lợi điều trị ngoại trú lên tới",
  special_offers_death_benefit: "Quyền lợi bảo hiểm tử vong không do tai nạn từ",
  special_offers_up_to: "trở lên",
  special_offers_death_benefit_pay_more: "Quyền lợi bảo hiểm tử vong do tai nạn trả thêm lên đến",
  error_local_account: "Đăng ký thất bại do chương trình khuyến mại đã hết hạn",
  //Auto payment
  cancel_register: "Hủy đăng ký",
  detail_register: "Chi tiết đăng ký",
  my_auto_payment:"Các khoản thanh toán tự động của tôi",
  register_auto_payment: "Đăng ký tự động thanh toán",
  auto_payment_button: "Đăng ký thanh toán tự động",
  detail_info:"Thông tin chi tiết",
  detail_auto_payment_info:"Chi tiết thanh toán tự động",
  main_product_name: "Tên sản phẩm bảo hiểm chính",
  policy_start_date_1: "Ngày hiệu lực HĐBH",
  pay_frequency: "Định kỳ nộp phí",
  fee_frequency: "Phí định kì",
  pay_account:"Nguồn tài khoản thanh toán",
  cancel_action: "Hủy thao tác",
  cancel_auto_payment: "Hủy thanh toán tự động",
  cancel_auto_payment_confirm: "Tôi xác nhận hủy thanh toán tự động cho Hợp đồng Bảo hiểm với các thông tin như sau: ",
  confirm_cancel_auto_payment_title: "Xác nhận hủy thanh toán tự động",
  success_cancel_auto_payment: "Hủy thanh toán tự động thành công!",
  error_title:"Có lỗi xảy ra!",
  register: "Đăng ký",
  msg_success_register:"Đã đăng ký thanh toán tự động thành công!",
  title_confirm_register_auto_payment:"Xác nhận đăng ký thanh toán tự động",
  msg_confirm_register_auto_payment: "Tôi xác nhận đăng ký thanh toán tự động cho Hợp đồng Bảo hiểm với các thông tin như sau: ",
  agree_msg_1:"Tôi đồng ý với",
  agree_msg_2: "các điều khoản và điều kiện sử dụng dịch vụ",
  auto_payment_list: "Danh sách thanh toán tự động"
};

export default vi;
